var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.0508 3.55078C17.0108 3.55078 21.0508 7.59078 21.0508 12.5508C21.0508 17.5108 17.0108 21.5508 12.0508 21.5508C7.09078 21.5508 3.05078 17.5108 3.05078 12.5508C3.05078 7.59078 7.09078 3.55078 12.0508 3.55078ZM12.0508 1.55078C5.97078 1.55078 1.05078 6.47078 1.05078 12.5508C1.05078 18.6308 5.97078 23.5508 12.0508 23.5508C18.1308 23.5508 23.0508 18.6308 23.0508 12.5508C23.0508 6.47078 18.1308 1.55078 12.0508 1.55078Z",
  fill: "black"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0494 9.67938C11.3594 9.67938 10.8594 9.19938 10.8594 8.51938C10.8594 7.83938 11.3594 7.35938 12.0494 7.35938C12.7394 7.35938 13.2394 7.83938 13.2394 8.51938C13.2394 9.19938 12.7394 9.67938 12.0494 9.67938Z",
  fill: "black"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0488 10.8984H11.0488V17.6784H13.0488V10.8984Z",
  fill: "black"
})));
export default SvgInfoBlack;